import React from "react";
import { motion } from "framer-motion";
import { MapPin, CheckCircle2, Building2, Waves } from "lucide-react";
import { AREAS } from "../data/content";

const ICONS = { budapest: Building2, keszthely: Waves };

export default function Areas() {
  const entries = Object.entries(AREAS);
  return (
    <section id="teruletek" className="py-24 lg:py-32 bg-slate-50">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs sm:text-sm uppercase tracking-widest font-bold text-sky-600 bg-sky-50 px-3 py-1 rounded-full inline-block mb-4 border border-sky-100">
            Hol dolgozom
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Két régióban is <span className="text-sky-600">az Ön szolgálatában.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {entries.map(([key, area], i) => {
            const Icon = ICONS[key];
            return (
              <motion.div
                key={key}
                data-testid={`area-box-${key}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="rounded-3xl bg-white border border-slate-200 shadow-xl shadow-slate-100/70 p-8 lg:p-9 hover:border-sky-300 transition-colors"
              >
                <div className="flex items-center gap-3 mb-6">
                  <span className="w-12 h-12 rounded-2xl bg-sky-600 flex items-center justify-center shadow-lg shadow-sky-600/20 shrink-0">
                    <Icon className="w-6 h-6 text-white" />
                  </span>
                  <div className="inline-flex items-center gap-2 text-sky-700 font-display font-extrabold text-lg">
                    <MapPin className="w-4 h-4 shrink-0" /> {area.label}
                  </div>
                </div>
                <div className="flex flex-wrap gap-2.5">
                  {area.places.map((p) => (
                    <span
                      key={p}
                      className="inline-flex items-center gap-1.5 bg-sky-50 text-slate-700 border border-sky-100 rounded-full px-3.5 py-2 text-sm font-semibold"
                    >
                      <CheckCircle2 className="w-4 h-4 text-sky-500 shrink-0" /> {p}
                    </span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>

        <p className="mt-8 text-center text-sm text-slate-500">
          A felsorolt településeken kívül is? Kérdezzen bátran, biztosan megoldjuk!
        </p>
      </div>
    </section>
  );
}
